import React, { useEffect } from 'react';
import Card from '@applied/dragonfruit/src/components/Card/Card';
import Icon from '@applied/dragonfruit/src/components/Icon/Icon';
import Flex from '@applied/dragonfruit/src/components/Layout/Flex';
import { Typography } from '@applied/dragonfruit/src/components/Text/Typography';

import { useAppliedLogoSrc } from 'utils/reskin_utils';

import '../basic-page-style.scss';

export function NotFoundPage(): JSX.Element {
  const logoSrc = useAppliedLogoSrc();
  useEffect(function updateTabTitle() {
    document.title = '404 Not Found';
  }, []);

  return (
    <Flex className="basic-page" justify="center" alignment="center">
      <Card
        className="content-container"
        direction="column"
        padding="xxl"
        gap="md"
        justify="center"
        alignment="center"
      >
        <Flex direction="row" alignment="center" justify="center">
          <Icon src={logoSrc} height={76.8} />
          <Typography variant="title">404 Not Found</Typography>
        </Flex>
        <Typography variant="body">The requested resource does not exist.</Typography>
      </Card>
    </Flex>
  );
}
